import axios from "axios";

class CertificationService {

    static BASE_URL = process.env.REACT_APP_BASE_URL2;

    static async addCertification(payload) {
        try {
          const response = await axios.post(`${CertificationService.BASE_URL}/sme/api/addCertificate`, payload);
          return response.data; // Directly return the response data
        } catch (error) {
        console.error("API Error:", error.response || error.message);
        throw new Error(
          error.response?.data?.message || "Failed to communicate with the server."
        );
        }
      }

      static async getCertificationsByUserId(userId) {
        //return axios.get(`/certifications/user/${userId}`).then(res => res.data);
        try {
          const response = await axios.get(`${CertificationService.BASE_URL}/sme/api/retrieveAllCertificationsByUserId/${userId}`);
          return response.data; // Directly return the response data
        } catch (error) {
        console.error("API Error:", error.response || error.message);
        throw new Error(
          error.response?.data?.message || "Failed to communicate with the server."
        );
        }
      }
      
      static async updateCertification(payload) {
        try {
          const response = await axios.put(`${CertificationService.BASE_URL}/sme/api/updateCertificate`, payload);
          return response.data; // Directly return the response data
        } catch (error) {
        console.error("API Error:", error.response || error.message);
        throw new Error(
          error.response?.data?.message || "Failed to communicate with the server."
        );
        }
      }
      
      static async deleteCertification(certificationId) {
       // return axios.delete(`/certifications/${certificationId}`);
        try {
          const response = await axios.delete(`${CertificationService.BASE_URL}/sme/api/deleteCertificate/${certificationId}`);
          return response.data; // Directly return the response data
        } catch (error) {
        console.error("API Error:", error.response || error.message);
        throw new Error(
          error.response?.data?.message || "Failed to communicate with the server."
        );
        }
      }
}

export default CertificationService;